import StartPage from './components/StartPage.vue';
import Contact from './components/Contact.vue';
import MenuCard from './components/MenuCard.vue';


const routes = [
    { path: '/', component: StartPage },
    { path: '/menü', component: MenuCard },
    { path: '/kontakt', component: Contact }
];

export default routes;